import { ChevronDown } from "lucide-react";
import { faqV2Items } from "./faqV2Data";

/**
 * FAQ compacte de la page d'accueil.
 * Utilise <details>/<summary> : le texte des réponses reste toujours dans le DOM,
 * donc entièrement crawlable même quand l'accordéon est fermé.
 */
const FaqV2 = () => (
  <section
    id="faq"
    aria-labelledby="faq-titre"
    className="scroll-mt-24 bg-background py-16 md:py-32"
  >
    <div className="mx-auto max-w-[1280px] px-5 md:px-8">
      <div className="grid gap-8 md:grid-cols-[38%_1fr] md:gap-16">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.18em] text-primary">FAQ</p>
          <h2
            id="faq-titre"
            className="mt-3 text-balance text-[1.7rem] font-medium leading-[1.15] tracking-tight md:text-4xl"
          >
            Les questions qu'on nous pose le plus souvent
          </h2>
        </div>

        <div className="divide-y divide-border border-t border-border">
          {faqV2Items.map((item) => (
            <details key={item.question} className="group py-4 md:py-5">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-base font-medium text-foreground md:text-lg">
                <span>{item.question}</span>
                <ChevronDown
                  className="h-5 w-5 shrink-0 text-muted-foreground transition-transform group-open:rotate-180"
                  aria-hidden="true"
                />
              </summary>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-muted-foreground md:text-base">
                {item.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default FaqV2;
